export const keys = {
    all: ["group-marketing-report"],
    data: (groupID: number, dateTime: Date | undefined, tagAssociationTypeId: number | undefined) => [
        ...keys.all,
        "data", {
            groupID,
            dateTime,
            tagAssociationTypeId
        }
    ],
    tats: (groupID: number) => [
        ...keys.all,
        "tats", {
            groupID
        }
    ]


};
